
const updateTeamStatsGame = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const { gameData = {}, liveData = {} } = action?.data ?? {};
        const teams = gameData.teams;
        const { home = {}, away = {} } = liveData?.linescore?.teams || {};
        const { boxscore = {} } = liveData;
        const homeBox = boxscore?.teams?.home || {};
        const awayBox = boxscore?.teams?.away || {};

        const homeId = teams?.home?.id;
        const awayId = teams?.away?.id;

        const homeName = teams?.home?.teamName;
        const awayName = teams?.away?.teamName;

        const sportId = teams?.home?.sport?.id;

        const homeStats = {
            team: homeId,
            name: homeName,
            sportId,
            runs: home?.runs || 0,
            hits: home?.hits || 0,
            hr: homeBox?.teamStats?.batting?.homeRuns || 0,
            totalBases: homeBox?.teamStats?.batting?.totalBases || 0,
            stolenBases: homeBox?.teamStats?.batting?.stolenBases || 0,
            leftOnBase: home?.leftOnBase || 0,
            errors: home?.errors || 0
        };

        const awayStats = {
            team: awayId,
            name: awayName,
            sportId,
            runs: away?.runs || 0,
            hits: away?.hits || 0,
            hr: awayBox?.teamStats?.batting?.homeRuns || 0,
            totalBases: awayBox?.teamStats?.batting?.totalBases || 0,
            stolenBases: awayBox?.teamStats?.batting?.stolenBases || 0,
            leftOnBase: away?.leftOnBase || 0,
            errors: away?.errors || 0
        };

        return Object.assign({}, state, {
            homeStats: { ...homeStats, otherteam: awayStats },
            awayStats: { ...awayStats, otherteam: homeStats }
        });
    }

    return state;
};

export default updateTeamStatsGame;
